<template>
  <div>
      <v-row no-gutters align="center">
        <v-col cols="6" class="pt-8">
          <modal-cadu :close="close" :width="1131.52" v-model="show">
            <div slot="all" class="pt-5 pb-5 px-10">
              <div slot="header">
                <div
                  class="font-primaria headline font-weight-bold pb-4"
                  style="color: #00995D"
                >SELECIONAR UNIMED</div>
                <div slot="body">
                  <v-row>
                    <v-col cols="12" sm="12" md="4" class="pb-0">
                        <autocomplete-cadu
                          title="Unimed"
                          placeholder
                          :value="unimedSelecionada"
                          :items="listaUnimeds.map(el => el.textoExibicao)"
                          :disabled="false"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @input="value => inserirUnimedListaUnimedFiltradas(value)"
                          @index="value => indexUnimedSelecionada = value"
                        />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" :class="$vuetify.breakpoint.xs ? '' : 'mx-3 container'">
                      <div class="mb-1">
                        <v-row>
                          <v-col cols="5" class="px-0 py-0" style="width:200px">
                            Relação de Unimeds
                          </v-col>
                          <v-col cols="5" class="px-0 py-0 ml-4">
                            Unimeds Selecionadas
                          </v-col>
                        </v-row>
                      </div>
                      <v-row justify="start">
                        <v-col cols="12" sm="12" md="4" class="box" @scroll="onScroll">
                          <div v-if="!loading">
                            <div class="mx-4">
                              <checkbox-cadu
                                v-model="selAll"
                                @click="selectAll"
                                :disable="unimedsFiltradas.length <= 0"
                              >
                                <div slot="text">Todos as Unimeds</div>
                              </checkbox-cadu>
                            </div>
                            <div
                              class="mx-4"
                              v-for="(unimed, index) in unimedsFiltradas"
                              v-show="index < itemsLimit"
                              :key="index"
                            >
                              <checkbox-cadu
                                v-model="checkLeft"
                                @input="selectLeft"
                                :value="unimed.id"
                              >
                               <div slot="text" v-if="unimed.textoExibicao">

                                  <v-tooltip bottom v-if="unimed.textoExibicao.length > 35">
                                    <template v-slot:activator="{ on }">
                                      <div v-on="on">
                                        {{unimed.textoExibicao.substring(0,34)}}
                                      </div>
                                    </template>

                                    <span>{{ unimed.textoExibicao }}</span>

                                  </v-tooltip>

                                  <div v-else>
                                    {{ unimed.textoExibicao }}
                                  </div>

                                </div>
                              </checkbox-cadu>
                            </div>
                          </div>
                          <component-loading :value="loading" />
                        </v-col>
                        <v-col cols="12" sm="12" md="1">
                          <v-row align="center" style="height: 100%">
                            <v-col cols="12" class="actions">
                              <div align="center" indent="center">
                                <button @click="addUnimed()">
                                  <icon
                                    name="arrow-right-circle"
                                    :size="35"
                                    style="color: #00995D"
                                    class="mb-3"
                                  />
                                </button>
                              </div>
                              <div align="center" indent="center">
                                <button @click="removeUnimed()">
                                  <icon
                                    name="arrow-left-circle"
                                    :size="35"
                                    style="color: #00995D"
                                    class="mb-3"
                                  />
                                </button>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col :class="$vuetify.breakpoint.xs ? '' : ' mx-3 pt-0 container'">
                          <v-row >
                            <v-col cols="12" sm="12" md="7" class="box">
                              <div v-show="!loadingRemove">
                                <div class="mx-4">
                                  <checkbox-cadu
                                    v-model="remAll"
                                    @click="removeAll"
                                    :disable="unimedSelecionadas.length <= 0"
                                  >
                                    <div slot="text">Todos as Unimeds</div>
                                  </checkbox-cadu>
                                </div>
                                <div
                                  class="mx-4"
                                  v-for="(unimed, index) in unimedSelecionadas"
                                  :key="index"
                                >
                                  <checkbox-cadu
                                    v-model="checkRight"
                                    @input="selectRight"
                                    :value="unimed.id"
                                  >
                                  <div slot="text" v-if="unimed.textoExibicao">

                                    <v-tooltip bottom v-if="unimed.textoExibicao.length > 35">

                                      <template v-slot:activator="{ on }">
                                        <div v-on="on">
                                          {{unimed.textoExibicao.substring(0,34)}}
                                        </div>
                                      </template>

                                      <span>{{ unimed.textoExibicao }}</span>

                                    </v-tooltip>

                                    <div v-else>
                                      {{ unimed.textoExibicao }}
                                    </div>
                                  </div>
                                  </checkbox-cadu>
                                </div>
                              </div>
                              <component-loading :value="loadingRemove" />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
                <div slot="footer">
                  <div v-if="!$vuetify.breakpoint.xs">
                    <v-row justify="end" class="linha mt-4">
                      <v-row justify="start">
                        <v-col cols="auto">
                          <button-cadu text="VOLTAR" outline @click="show = false"/>
                        </v-col>
                      </v-row>
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          text="LIMPAR"
                          @click="limpar"
                          :backColor="$vuetify.theme.themes.light.primary2"
                        />
                      </v-col>
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          :text="'FILTRAR'"
                          class="px-4"
                          :backColor="$vuetify.theme.themes.light.primary1"
                          @click="filtrar"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else>
                    <v-row justify="end" class="linha mt-4">
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          :text="'FILTRAR'"
                          block
                          :backColor="$vuetify.theme.themes.light.primary1"
                          @click="filtrar"
                        />
                      </v-col>
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          text="LIMPAR"
                          block
                          :backColor="$vuetify.theme.themes.light.primary2"
                        />
                      </v-col>
                      <v-col cols="12">
                        <button-cadu text="VOLTAR" @click="show = false" outline block />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </modal-cadu>
        </v-col>
      </v-row>

      <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import AtualizacaoBeneficiario from '../../../../../services/TransacaoOnline/AtualizacaoBeneficiario'

import { remove } from 'lodash'

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      close: true,
      show: this.value,
      tokenBearer: localStorage.getItem('tokenBearer'),

      // Selecionar tudo do direito e esquerdo do grid
      selAll: false,
      remAll: false,

      // Loadings
      loadingRemove: false,
      loading: false,

      unimedSelecionada: '',
      listaUnimeds: [],
      indexUnimedSelecionada: -1,
      primeiroFiltro: true, // Quando carregar e selecionar unimed ira limpar unimeds selecionadas

      itemsLimit: 20,

      // Array de unimed do grid do lado direito e esquerdo
      checkRight: [],
      checkLeft: [],
      unimedsFiltradas: [],
      unimedSelecionadas: [],

      // Erro
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      primeiraVez: false
    }
  },
  methods: {
    // Metodos de ação da modal
    closeAcao () {
      this.$emit('input', false)
      this.cancelar()
      this.unimedsFiltradas = []
      this.unimedSelecionadas = []
    },
    cancelar () {
      this.limpar()
      this.show = false
    },
    async limpar () {
      this.primeiraVez = false
      this.remAll = false
      this.selAll = false
      this.checkLeft = []
      this.checkRight = []
      this.unimedsFiltradas = []
      this.unimedSelecionadas = []
      this.unimedSelecionada = ''
      await this.buscarUnimed()
    },

    // Metodos de selecionar os checkboxs
    selectLeft (input) {
      this.checkLeft = input
      this.selAll = this.checkLeft.length >= this.unimedsFiltradas.length
    },
    selectRight (input) {
      this.checkRight = input
      this.remAll = this.checkRight.length >= this.unimedSelecionadas.length
    },

    // Metodos de adicionar e remover unimed nos grids
    async removeUnimed () {
      this.loadingRemove = true

      try {
        await this.sleep(100)
        remove(this.unimedSelecionadas, (el, index) => {
          let bool = this.checkRight.includes(el.id)
          if (bool) {
            this.unimedsFiltradas.push(this.unimedSelecionadas[index])
            this.unimedsFiltradas.sort((a, b) => a.textoExibicao.localeCompare(b.textoExibicao))
            return true
          }
        })
        this.checkRight = []
      } catch (err) {
        console.error(err)
      }
      this.loadingRemove = false
      this.remAll = false
    },

    async addUnimed () {
      this.loading = true
      try {
        await this.sleep(100)
        remove(this.unimedsFiltradas, (el, index) => {
          let bool = this.checkLeft.includes(el.id)
          if (bool) {
            this.unimedSelecionadas.push(this.unimedsFiltradas[index])
            this.unimedSelecionadas.sort((a, b) =>
              a.textoExibicao.localeCompare(b.textoExibicao)
            )
            return true
          }
        })
        this.checkLeft = []
      } catch (err) {
        console.error(err)
      }
      this.loading = false
      this.selAll = false
    },

    selectAll (value) {
      this.checkLeft = []
      if (this.selAll) {
        this.unimedsFiltradas.forEach(unimed => {
          this.checkLeft.push(unimed.id)
        })
      }
    },

    removeAll (value) {
      this.checkRight = []
      if (this.remAll) {
        this.unimedSelecionadas.forEach(unimed => {
          this.checkRight.push(unimed.id)
        })
      }
    },

    async inserirUnimedListaUnimedFiltradas (value) {
      if (!value) return
      const unimed = this.listaUnimeds.filter((el) => el.textoExibicao === value)
      remove(this.listaUnimeds, (el) => el.textoExibicao === value)

      if (!this.primeiraVez) {
        this.unimedsFiltradas = unimed
        this.primeiraVez = true
        return
      }
      this.unimedsFiltradas.push(unimed[0])
    },

    filtrar () {
      if (this.unimedSelecionadas.length > 0) {
        var parametros = new URLSearchParams()
        this.unimedSelecionadas.forEach(item => {
          parametros.append('unimedIds', item.id)
        })

        this.$emit('filtrar', parametros.toString())
        this.show = false
      } else {
        this.error = true
        this.errObj.error = 'Selecione ao menos uma Unimed!'
      }
    },

    // Metodo buscar as unimed default do grid
    async buscarUnimed () {
      this.loading = true
      this.primeiroFiltro = true
      await this.getUnimesFiltradas()
      this.loading = false
    },

    // Requests
    async getUnimesFiltradas () {
      let listarUnimed = new AtualizacaoBeneficiario(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await listarUnimed.getUnimeds()
        this.unimedsFiltradas = response.data
        this.listaUnimeds = response.data
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    // Utils
    async sleep (forHowLong) {
      function timeout (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      }
      await timeout(forHowLong)
    },
    onScroll (event) {
      if (this.itemsLimit >= this.unimedsFiltradas) return

      const content = event.target
      const showMoreItems =
        content.scrollHeight - (content.scrollTop + content.clientHeight) < 100

      if (showMoreItems) {
        this.itemsLimit += 10
      }
    }
  },
  watch: {
    value () {
      this.show = this.value
    },
    show () {
      if (!this.show) {
        this.closeAcao()
      } else {
        this.buscarUnimed()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
    .box
        border: 1px solid #9E9E9E
        border-radius: 5px
        height: 300px
        overflow-x: hidden
        overflow-y: visible

    ::-webkit-scrollbar
        width: 5px

    ::-webkit-scrollbar-track
        box-shadow: 0 0 5px #DEE2E6
        margin: 15px 5px 6.5px 5px

    ::-webkit-scrollbar-thumb
        background: #9E9E9E
        height: 100px
</style>
